import React from "react";
import { useIntl } from "react-intl";

const CommunityTemplatesSearch = ({editSearchTerm, searchTerm}) => {

  const searchPlaceholder = useIntl().formatMessage({
    id: "ask.pages.edit.communityTemplates.searchPlaceholder"
  });

  return (
    <input
      className="community-templates-search-input"
      type="text"
      value={searchTerm}
      onChange={(e) => editSearchTerm(e)}
      placeholder={searchPlaceholder}
    />
  );
};

export default CommunityTemplatesSearch;